module.exports = __webpack_public_path__ + "media/images/social_svgs/instagram-09c17ccce9892086c5c14c64b774989e.svg";